export default __webpack_public_path__ + "static/media/agent.844441a3.png";